import {
  isValidCNPJ,
  isValidCPF,
  isValidEmail,
} from "@brazilian-utils/brazilian-utils";
import { Box, RadioGroup, Radio, Text } from "@chakra-ui/react";
import { Row, Col } from "antd";
import { Control, UseFormSetValue, UseFormWatch } from "react-hook-form";
import UploadImagem from "components/Input/UploadImagem";
import InputMask from "components/Input/InputMask";
import InputCnpj, { CnpjResponse } from "components/Input/InputCnpj";
import Field from "components/Input/Field";
import { EmpresaDetalhe } from "core/resources/types/empresa";
import { useMemo, useState } from "react";
import FormContatos from "components/FormContatos";
import { PessoaTipo } from "features/pessoas/typings";
import { EmpresaResponse, TipoCadastroEmpresa } from "resources/types/empresa";
import DadosDeEndereco from "ui/components/FormEndereco";

function DadosGerais({
  control,
  setField,
  watch,
  isCondominio,
  tipoCadastroEmpresa,
  onLoadedCnpj,
  hideFieldsBeforeSearchCNPJ,
  isEdit,
  forceEditDocument,
  form,
  isUnidadePessoaEdit,
  showEndereco = false,
}: {
  isEdit?: boolean;
  forceEditDocument?: boolean;
  control: Control<EmpresaResponse, object>;
  setField: UseFormSetValue<EmpresaDetalhe>;
  watch: UseFormWatch<any>;
  isCondominio?: boolean;
  tipoCadastroEmpresa?: TipoCadastroEmpresa;
  onLoadedCnpj?: () => void;
  hideFieldsBeforeSearchCNPJ?: boolean;
  isUnidadePessoaEdit?: boolean;
  form?: EmpresaDetalhe;
  showEndereco?: boolean;
}) {
  const [jaBuscou, setJaBuscou] = useState(!!isEdit);

  console.log('VERSAO NOVA')

  const afterLoadCnpj = (data: CnpjResponse) => {
    if (data) {
      setJaBuscou(true);

      const { pessoa, endereco } = data;

      setField(
        "pessoa.classificacaoTributariaId",
        pessoa.classificacaoTributariaId || undefined
      );
      setField(
        "pessoa.naturezaJuridicaId",
        pessoa.naturezaJuridicaId || undefined
      );
      setField("pessoa.cnaeId", pessoa.cnaeId || undefined);
      setField("pessoa.nome", pessoa.nome);
      setField("pessoa.email", pessoa.email ?? "");
      setField("pessoa.documento", pessoa.documento);
      setField("pessoa.celular", pessoa.celular ?? "");
      setField("pessoa.telefone", pessoa.telefone ?? "");
      setField("pessoa.inscricaoEstadual", pessoa.inscricaoEstadual ?? "");
      setField("pessoa.nomeFantasia", pessoa.nomeFantasia ?? "");
      setField("endereco.cep", endereco?.cep ?? "");
      setField("endereco.numero", endereco?.numero ?? "");
      setField("endereco.complemento", endereco?.complemento ?? "");
      setField("endereco.bairro", endereco?.bairro ?? "");
      setField("endereco.logradouro", endereco?.logradouro ?? "");
      setField("endereco.cidadeId", endereco?.cidadeId ?? "");
      setField("endereco.estadoId", endereco?.estadoId ?? "");

      if (typeof onLoadedCnpj === "function") {
        onLoadedCnpj();
      }
    }
  };

  const isPessoaFisica = form?.pessoaTipo === PessoaTipo.Fisica;

  const displayOutherFields = useMemo(() => {
    if (isPessoaFisica) {
      return true;
    }

    if (isEdit) {
      return true;
    }

    if (hideFieldsBeforeSearchCNPJ) {
      if (jaBuscou) {
        return true;
      }

      return false;
    }

    return true;
  }, [isPessoaFisica, isEdit, hideFieldsBeforeSearchCNPJ, jaBuscou]);

  console.log('displayOutherFields', displayOutherFields);

  const getPlaceholderPessoaNome = () => {
    const map = {
      [TipoCadastroEmpresa.Fornecedor]: "Nome do fornecedor",
      [TipoCadastroEmpresa.Cliente]: "Nome do cliente",
    };

    return tipoCadastroEmpresa
      ? map[tipoCadastroEmpresa]
      : "Nome do condomínio";
  };

  const showEmail = isPessoaFisica && !tipoCadastroEmpresa;

  const disabledCpfCnpj = !forceEditDocument && isEdit && isCondominio;

  return (
    <>
      {isCondominio ? (
        <Box as={Row} mb={"16px"} gutter={16}>
          <Box as={Col} md={8}>
            <Field
              label="Data de cadastro"
              control={control}
              inputProps={{ type: "date" }}
              name="dateCreated"
            />
          </Box>
        </Box>
      ) : null}

      <Box d="flex" as={Row} gutter={16} h="150px" mb={8}>
        <Box as={Col} md={19} d="flex" flexDir="column">
          {!isEdit ? (
            <Field
              control={control}
              name="pessoaTipo"
              rules={{
                required: true,
              }}
              render={({ field, isInvalid }) => (
                <RadioGroup
                  value={field.value}
                  onChange={field.onChange}
                  as={Row}
                  gutter={32}
                  mb={6}
                >
                  <Box as={Col} md={6}>
                    <Radio
                      isInvalid={isInvalid}
                      color={isInvalid ? "red" : undefined}
                      value={PessoaTipo.Fisica}
                    >
                      Pessoa Física
                    </Radio>
                  </Box>
                  <Box as={Col} md={6}>
                    <Radio
                      isInvalid={isInvalid}
                      color={isInvalid ? "red" : undefined}
                      value={PessoaTipo.Juridica}
                    >
                      Pessoa Jurídica
                    </Radio>
                  </Box>
                </RadioGroup>
              )}
            />
          ) : null}
          <Box as={Row} gutter={16} mt="auto">
            <Box as={Col} md={12}>
              <Field
                inputProps={disabledCpfCnpj ? { opacity: 0.6 } : null}
                label={isPessoaFisica ? "CPF" : "CNPJ"}
                control={control}
                name="pessoa.documento"
                render={({ field, isInvalid }) => {
                  return isPessoaFisica ? (
                    <InputMask
                      {...field}
                      disabled={disabledCpfCnpj}
                      isInvalid={isInvalid}
                      mask="999.999.999-99"
                      placeholder="XXX.XXX.XXX-XX"
                    />
                  ) : (
                    <InputCnpj
                      disabled={disabledCpfCnpj}
                      isInvalid={isInvalid}
                      {...field}
                      onLoadCnpj={afterLoadCnpj}
                    />
                  );
                }}
                rules={{
                  required: tipoCadastroEmpresa ? false : "Campo obrigatório",
                  validate: (v) => {
                    if (!tipoCadastroEmpresa && !isPessoaFisica) {
                      return isValidCNPJ(v) || "CNPJ inválido";
                    }
                    if (v?.length && !isPessoaFisica) {
                      return isValidCNPJ(v) || "CNPJ inválido";
                    }
                    if (v?.length && isPessoaFisica) {
                      return isValidCPF(v) || "CPF inválido";
                    }
                    return true;
                  },
                }}
              />
            </Box>
            {displayOutherFields ? (
              <Box as={Col} md={12}>
                <Field
                  label={isPessoaFisica ? "Nome" : "Razão Social"}
                  control={control}
                  name="pessoa.nome"
                  inputProps={{
                    placeholder: getPlaceholderPessoaNome(),
                  }}
                  rules={{ required: "Campo obrigatório" }}
                />
              </Box>
            ) : null}
            {showEmail ? (
              <Box as={Col} md={12} mt={4}>
                <Field
                  label="Email"
                  control={control}
                  name="pessoa.email"
                  inputProps={{
                    type: "email",
                  }}
                  rules={{
                    required: tipoCadastroEmpresa ? false : "Campo obrigatório",
                    validate: (v) => {
                      if (!tipoCadastroEmpresa) {
                        return isValidEmail(v) || "Email inválido";
                      }
                      if (v?.length) {
                        return isValidEmail(v) || "Email inválido";
                      }
                      return true;
                    },
                  }}
                />
              </Box>
            ) : null}
          </Box>
        </Box>
        {displayOutherFields ? (
          <Box as={Col} md={5}>
            <Field
              control={control}
              name="pessoa.imagemUrl"
              render={({ field }) => {
                return (
                  <UploadImagem
                    {...field}
                    isTenant
                    confirmButton="Enviar logotipo"
                  />
                );
              }}
            />
          </Box>
        ) : null}
      </Box>

      {isPessoaFisica &&
        tipoCadastroEmpresa === TipoCadastroEmpresa.Fornecedor ? (
        <Box as={Row} gutter={16}>
          <Box as={Col} md={8}>
            <Field label="RG" control={control} name="pessoa.rg" />
          </Box>
          <Box as={Col} md={6}>
            <Field label="PIS/CONFINS" control={control} name="pessoa.pis" />
          </Box>
          <Box as={Col} md={6}>
            <Field
              label="Data de nascimento"
              control={control}
              name="pessoa.dataNascimento"
              inputProps={{
                type: "date",
              }}
            />
          </Box>
        </Box>
      ) : null}

      <>
        {!isPessoaFisica ? (
          <>
            {displayOutherFields ? (
              <Box as={Row} mb={"32px"} gutter={16}>
                <Box as={Col} md={12}>
                  <Field
                    label="Nome Fantasia"
                    control={control}
                    name="pessoa.nomeFantasia"
                    inputProps={{
                      placeholder: "Nome Fantasia",
                    }}
                    rules={{
                      required: tipoCadastroEmpresa
                        ? false
                        : "Campo obrigatório",
                    }}
                  />
                </Box>

                {!isCondominio ? (
                  <Box as={Col} md={6}>
                    <Field
                      label="Inscrição Estadual"
                      control={control}
                      name="pessoa.inscricaoEstadual"
                    />
                  </Box>
                ) : null}

                <Box as={Col} md={6}>
                  <Field
                    label="Inscrição Municipal"
                    control={control}
                    name="pessoa.inscricaoMunicipal"
                  />
                </Box>
              </Box>
            ) : null}

            <Box as={Row} gutter={16}>
              {displayOutherFields ? (
                <Box as={Col} xs={8} md={8}>
                  <Field
                    label="Email"
                    control={control}
                    name="pessoa.email"
                    inputProps={{
                      type: "email",
                    }}
                    rules={{
                      required: tipoCadastroEmpresa
                        ? false
                        : "Campo obrigatório",
                      validate: (v) => {
                        if (!tipoCadastroEmpresa) {
                          return isValidEmail(v) || "Email inválido";
                        }
                        if (v?.length) {
                          return isValidEmail(v) || "Email inválido";
                        }
                        return true;
                      },
                    }}
                  />
                </Box>
              ) : null}

              {displayOutherFields ? (
                <>
                  {isCondominio ? (
                    <Box as={Col} md={8}>
                      <Field
                        label="Nome do responsável"
                        control={control}
                        shouldUnregister
                        name="nomeResponsavel"
                        rules={{
                          required: isCondominio ? "Campo obrigatório" : false,
                        }}
                      />
                    </Box>
                  ) : null}

                  {isCondominio ? (
                    <Box as={Col} md={4}>
                      <Field
                        label="CPF do responsável"
                        shouldUnregister
                        control={control}
                        name="documentoResponsavel"
                        rules={{
                          required: !tipoCadastroEmpresa
                            ? "Campo obrigatório"
                            : false,
                          validate: (v) => {
                            if (!tipoCadastroEmpresa) {
                              return isValidCPF(v) || "CPF inválido";
                            }
                            if (v?.length) {
                              return isValidCPF(v) || "CPF inválido";
                            }
                            return true;
                          },
                        }}
                        render={({ field, isInvalid }) => {
                          return (
                            <InputMask
                              {...field}
                              isInvalid={isInvalid}
                              mask="999.999.999-99"
                              placeholder="XXX.XXX.XXX-XX"
                            />
                          );
                        }}
                      />
                    </Box>
                  ) : null}

                  {isCondominio ? (
                    <Box as={Col} md={4}>
                      <Field
                        label="Data de nascimento do responsável"
                        shouldUnregister
                        control={control}
                        name="dataNascimentoResponsavel"
                        rules={{
                          required: "Campo obrigatório"
                        }}
                        inputProps={{
                          type: 'date'
                        }}
                      />
                    </Box>
                  ) : null}
                </>
              ) : null}
            </Box>
          </>
        ) : null}

        {showEndereco && form?.endereco && !isEdit ? (
          <Box mt={8}>
            <Text color={"#8291A9"} fontWeight={"500"} fontStyle={"italic"}>
              Endereço
            </Text>
            <DadosDeEndereco
              control={control}
              setField={setField}
              required={false}
              shouldUnregister={true}
              watch={watch}
            />
          </Box>
        ) : null}

        <Box mt={8} maxW="60%" minW="500px">
          <FormContatos
            hideCobranca={!isUnidadePessoaEdit}
            control={control}
            name="pessoa.contatos"
          />
        </Box>
      </>
    </>
  );
}

export default DadosGerais;
